import { styled } from "@mui/material/styles";
import { Tab } from "@mui/material";

export const StyledTab = styled(Tab)(({ theme, size = "medium" }) => ({
  fontSize: 13,
  textTransform: "none",
  minHeight: "45px",
}));
